import { render, staticRenderFns } from "./import.vue?vue&type=template&id=3bbddf16&scoped=true&"
import script from "./import.vue?vue&type=script&lang=ts&"
export * from "./import.vue?vue&type=script&lang=ts&"
import style0 from "./import.vue?vue&type=style&index=0&id=3bbddf16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbddf16",
  null
  
)

export default component.exports